import { AppBar, Box, Toolbar } from "@mui/material";
import React from "react";
import PersonalArchitectLogo from "../../assets/img/personal-architect-logo.png";

const Header = (props) => {
  return (
    <AppBar
      position="sticky"
      sx={{ backgroundColor: "#ffffff", boxShadow: 1 }}
    >
      <Toolbar>
        <Box
          component="img"
          src={PersonalArchitectLogo}
          alt="Personal Architect"
          sx={{ height: 36 }}
        ></Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
